// extracted by mini-css-extract-plugin
module.exports = {"customMenu":"Menu_customMenu__2pjT4","navbarHidden":"Menu_navbarHidden__w58OE"};